import { Text } from "@mantine/core";
import { IconClock } from "@tabler/icons-react";
import { useEffect, useState } from "react";

import styles from "./greeting.module.css";

export const AUTO_DISMISS_MS = 2 * 60 * 1000;

interface Props {
    durationMs: number;
    onTimeout: () => void;
}

const TICK_MS = 1000;

function formatRemaining(ms: number): string {
    const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function AutoDismissCountdown({ durationMs, onTimeout }: Props) {
    const [remainingMs, setRemainingMs] = useState(durationMs);

    useEffect(() => {
        const deadline = Date.now() + durationMs;
        const interval = setInterval(() => {
            const remaining = deadline - Date.now();
            if (remaining <= 0) {
                clearInterval(interval);
                setRemainingMs(0);
                onTimeout();
                return;
            }
            setRemainingMs(remaining);
        }, TICK_MS);
        return () => clearInterval(interval);
    }, [durationMs, onTimeout]);

    const formatted = formatRemaining(remainingMs);

    return (
        <Text component="span" role="timer" aria-label={`Auto-closing in ${formatted}`} className={styles.countdown}>
            <IconClock size={14} className={styles.countdownIcon} />
            Auto-closing in {formatted}
        </Text>
    );
}
